/**
 * 백엔드(LocalDateTime)에서 내려오는 ISO 형식 문자열("yyyy-MM-ddTHH:mm:ss[.SSS]")을
 * 화면 표시용 "yyyy.MM.dd HH:mm" 형식으로 변환한다.
 */
export function formatDateTime(value) {
  if (!value) return '-';

  // 가장 흔한 케이스: 백엔드가 내려주는 ISO 문자열을 정규식으로 직접 파싱한다.
  // (타임존/브라우저별 Date 파싱 차이에 영향받지 않도록 문자열 그대로 처리)
  const match = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/.exec(value);
  if (match) {
    const [, y, m, d, h, min] = match;
    return `${y}.${m}.${d} ${h}:${min}`;
  }

  // 그 외 형식이면 Date 파싱으로 한 번 더 시도한다.
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}.${pad(date.getMonth() + 1)}.${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
